<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch1">
<div class="chapterHead">
<p class="centerImage0"><img alt="image" src="images/ch1.jpg" width="4%"/></p>
</div>
<p class="paraNoIndent" style="text-indent: 0%;"><a id="pg-1">“How did you get in here?” a voice calls as you enter the waiting room at Eeek Laboratories. “That door is supposed to be locked at all times.”</a></p><a id="pg-1">
<p class="para" style="text-indent: 5%;">You and your friend Sam jump. You didn’t think anyone was around.</p>
<p class="para" style="text-indent: 5%;">Then you spot the receptionist sitting behind a tall desk. She’s a short, frizzy-haired redhead wearing too much lipstick for her thin lips. She glares at you as if she expects you to turn around and leave — as soon as you figure out you’re in the wrong place.</p>
<p class="para" style="text-indent: 5%;">“I’m looking for my mom,” you tell her.</p>
<p class="para" style="text-indent: 5%;">“Who’s your mom?” the receptionist asks. She starts to pack up her things to leave.</p>
<p class="para" style="text-indent: 5%;">You glance at the clock. It’s almost five-thirty — quitting time.</p>
<p class="para" style="text-indent: 5%;">“She’s the new lab technician,” you explain. “She’s working on some top secret experiments for Eeek.”</p>
<p class="para" style="text-indent: 5%;">“Really? For <em class="italic">Dr</em>. Eeek?” The receptionist gazes at you suspiciously.</p>
<p class="para" style="text-indent: 5%;">“Yeah — I guess,” you say.</p>
<p class="para" style="text-indent: 5%;">But really, you’re not sure. How come your mom never mentioned him before? Dr. Eeek? All she ever told you was that she had a new job in a <em class="italic">research</em> lab. You didn’t know there was a <em class="italic">medical</em> doctor involved. Doctors give you the creeps.</p>
</a><p class="extractLetterText" style="text-indent: 5%;"><a id="pg-1"><em class="italic">Go on to</em> </a><a href="#/e9780545841054_ch002"><em class="italic">PAGE 2</em></a>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841054_ch001.vue?0143d334